export default "__VITE_ASSET__CXcZgcnX__"